export default function Header() {
  return (
    <div className="text-center pt-2 pb-2">
      <div className="px-4 py-2 text-sm text-gray-700 flex">
        <span className="px-2 py-1">Powered By</span>
        <a href="https://transak.com" target="_blank" rel="noopener noreferrer">
          <img src="https://assets.transak.com/images/website/transak-logo.svg" width={70} alt="" height={70} />
        </a>
      </div>
    </div>
  );
}
